import { useState, useEffect } from 'react'
import { prepareRequest } from '@apollo/core'

const initialState = { isLoading: true, paymentMethods: [] }

export const usePaymentMethods = (operationType) => {
  const [state, setState] = useState(initialState)

  useEffect(() => {
    const request = prepareRequest({
      method: 'POST',
      url: 'payment/methods'
    })

    request({ operationType }).then(({ data: paymentMethods }) => {
      setState({ paymentMethods, isLoading: false })
    })
  }, [operationType])

  return state
}

export default usePaymentMethods
